/**
 * ===========================================
 * StudySpace ERP Frontend - useAuth Hook
 * ===========================================
 * 
 * Custom hook for accessing authentication context.
 * 
 * @file src/hooks/useAuth.js
 * @description Hook for auth context access
 */

import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

/**
 * Custom hook to access auth context
 * @returns {Object} Auth context value
 * @throws {Error} If used outside of AuthProvider
 */
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};

export default useAuth;
